import { createRoot } from "react-dom/client";
import { PriceEstimator } from "../../islands/PriceEstimator.js";

const el = document.querySelector<HTMLElement>('[data-island="price-estimator"]');
if (el) {
  const props = JSON.parse(el.getAttribute("data-props") || "{}");
  createRoot(el).render(<PriceEstimator {...props} />);
}
